import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
`;

export const ContentFields = styled.div`
  display: flex;
  padding: 10px 30px;
  label {
    font-weight: 600;
    font-size: 13px;
    color: ${({ theme }) => theme.primary.purple} !important;
  }
  input::placeholder,
  textarea::placeholder {
    color: rgba(46, 46, 46, 0.4);
    font-size: 13px;
  }
`;

export const ContentButtons = styled.div`
  width: 19em;
  display: flex;
  grid-gap: 1em;
  margin: 1em 2.5em;
  height: 60px;
`;
export const ButtonCancel = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ButtonCreate = styled.button`
    background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? `0 0 0 1px ${theme.primary.purpleLightOpacity}` : theme.neutral.gray[700],
    borderColor: theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: theme.primary.purpleLightOpacity,
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? theme.primary.purpleLightOpacity : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: theme.primary.purpleLightOpacity,
      },
      color: isFocused ? theme.button.primary : data.color,
    };
  },
};
